import { render } from "./Sidebar.vue?vue&type=template&id=73be56f5&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.scss?vue&type=style&index=0&id=73be56f5&lang=scss&scoped=true"
import "./Sidebar.vue?vue&type=style&index=1&id=73be56f5&lang=css"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73be56f5"]])

export default __exports__